import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ReactModal from 'react-responsive-modal';
import Button from '../utils/formElements/button';
import IconBack from '../utils/icons/back';
import * as settingsActions from '../../actions/settingsActions';
import './modal.css';
import 'react-responsive-modal/styles.css';
import { If } from '../renderConditional';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
    };
    this.handleStatus = this.handleStatus.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentDidMount() {
    if (!this.state.showModal) {
      this.props.showCloseIframe();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.showModal !== nextProps.showModal) {
      this.setState({
        showModal: nextProps.showModal,
      });
      if (nextProps.showModal) {
        this.props.hideCloseIframe();
      }
    }
  }

  onClose() {
    this.setState({ showModal: false }, () => {
      this.props.onClose();
      this.props.showCloseIframe();
    });
  }

  pathDismissList() {
    let isInDismissList = false;
    const path = window.location.pathname;
    const dismissList = [{ pathRegex: '.*/erro-limite.*' }];

    isInDismissList = dismissList.some((page) =>
      path.match(new RegExp(page.pathRegex, 'g'))
    );

    return isInDismissList;
  }

  handleStatus() {
    if (this.pathDismissList()) {
      this.onClose();
    } else {
      if (!this.state.showModal) {
        this.props.onOpen(this);
      }
      this.setState(
        (prevState) => ({ showModal: !prevState.showModal }),
        () => {
          this.props.hideCloseIframe();
        }
      );
    }
  }

  render() {
    const { handleOpen } = this.props;
    return [
      <div
        role='presentation'
        key={0}
        onClick={this.handleStatus}
        onKeyUp={this.handleStatus}
      >
        {handleOpen}
      </div>,
      <ReactModal
        styles={{
          overlay: {
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            padding: '0px',
          },
          modal: {
            background: '#fff',
            padding: '0',
            boxShadow: 'none',
            maxWidth: '320px',
            top: '0',
          },
        }}
        key={1}
        open={this.props.closed || this.state.showModal}
        contentLabel={this.props.contentLabel}
        onClose={this.props.onClose}
        showCloseIcon={false}
        closeOnOverlayClick={false}
        classNames={{ modal: `apa-modal ${this.props.className}` }}
      >
        <header className='modal-header'>
          <If condition={this.props.showHeaderButtonBack}>
            <Button
              icon={<IconBack fill='#808080' height='12' width='12' />}
              type='button'
              className='btn-back'
              text='Voltar'
              onClickHandler={this.onClose}
            />
          </If>
        </header>
        <div className='modal-body'>
          {this.props.children}
          <Button
            type='button'
            className={this.props.dismissClass}
            text={this.props.dismissText}
            onClickHandler={this.onClose}
            qaId={this.props.dismissQaId}
          />
        </div>
      </ReactModal>,
    ];
  }
}

Modal.defaultProps = {
  showModal: false,
  onClose: () => {},
  onOpen: () => {},
  dismissText: null,
  dismissClass: '',
  dismissQaId: '',
  contentLabel: '',
  handleOpen: <div />,
  children: <div />,
  className: '',
  showHeaderButtonBack: true,
};

Modal.propTypes = {
  showModal: PropTypes.bool,
  dismissText: PropTypes.string,
  dismissClass: PropTypes.string,
  dismissQaId: PropTypes.string,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  contentLabel: PropTypes.string,
  handleOpen: PropTypes.element,
  children: PropTypes.any,
  className: PropTypes.string,
  showCloseIframe: PropTypes.func,
  hideCloseIframe: PropTypes.func,
  closed: PropTypes.bool,
  showHeaderButtonBack: PropTypes.bool,
};

export default compose(connect(() => ({}), { ...settingsActions }))(Modal);
